import React from 'react';

interface ReadingStreakCardProps {
  streak: number;
  goal: number;
  daysLeft: number;
  className?: string;
}

const ReadingStreakCard: React.FC<ReadingStreakCardProps> = ({ streak, goal, daysLeft, className }) => {
  const percent = Math.min(streak / goal, 1);
  const percentDisplay = Math.round(percent * 100);
  const totalSegments = 8;
  const filledSegments = Math.round(percent * totalSegments);
  const segments = Array.from({ length: totalSegments }, (_, i) => i < filledSegments);

  return (
    <div className={`bg-white rounded-lg p-6 shadow-sm h-full flex flex-col ${className || ''}`}>
      {/* Header with icon and subtitle */}
      <div className="flex items-center gap-2 mb-1">
        <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-[#FFF0F6]">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 2L10.5 7H15L11.25 10L12.75 15L9 12L5.25 15L6.75 10L3 7H7.5L9 2Z" fill="#FF5CA0" />
          </svg>
        </span>
        <div>
          <div className="text-sm font-semibold text-gray-900 leading-tight">Reading Streak</div>
          <div className="text-xs text-gray-500 leading-tight">Keep it up!</div>
        </div>
      </div>
      {/* Streak Number */}
      <div className="flex-1 flex flex-col items-center justify-center">
        <span className="text-4xl font-bold text-gray-900 mb-1">{streak}</span>
        <span className="text-base text-gray-500 mb-3">Consecutive days</span>
        {/* Segmented Progress Bar */}
        <div className="flex items-center w-full justify-center mb-2">
          <div className="flex gap-1">
            {segments.map((filled, idx) => (
              <span
                key={idx}
                className={`w-6 h-2 rounded-full ${filled ? 'bg-pink-400' : 'bg-gray-200'}`}
              />
            ))}
          </div>
          <span className="ml-2 text-sm text-gray-500 font-semibold">{percentDisplay}%</span>
        </div>
      </div>
      {/* Motivational Message */}
      <div className="text-center mt-2">
        <span className="text-sm text-gray-700">{daysLeft} more days to go!</span>
      </div>
    </div>
  );
};

export default ReadingStreakCard; 